import React from "react";
import { cn } from "../../lib/utils";

export default function Skeleton({ className = "" }) {
  return <div className={cn("animate-pulse rounded-md bg-muted/70", className)} aria-hidden="true" />;
}
